import React from 'react'
import { GlobalContext } from '../../../context/GlobalContext'
import { CheckOutContext } from '../context/CheckOutContext'
import { CardActionArea, CardMedia, Box, Stack, Typography } from '@mui/material'


const UsingZarnipal = ({ data, paymentGateways, plan, web }) => {
    const G = React.useContext(GlobalContext)
    const CON = React.useContext(CheckOutContext)

    async function payWithZarni() {
        const res = await G.hitAxios({
            path: "/api/plan/pay-with-zarnipal",
            post: true,
            admin: false,
            obj: { amount: plan.cost, description: plan.plan_name, plan }
        })
        if (res.data.url && res.data.success) {
            window.location.href = res.data.url
        } else {
            alert("Something went wrong please check your zarnipal API keys")
        }
    }

    return (
        paymentGateways?.payment_id &&
        <CardActionArea onClick={payWithZarni} type='submit' >
            <Box border={1} style={{ cursor: 'pointer' }} bgcolor={'white'} borderRadius={1} p={1}>
                <Stack sx={{ mr: 1.5, ml: 1.5 }} direction={'row'} spacing={2} alignItems={'center'} >
                    <CardMedia component={'img'} src='/assets/zarnipal.png' sx={{ height: 35, width: 35 }} />
                    <Typography sx={{ textTransform: 'none' }} fontWeight={'bold'} color='black' >Zarinpal</Typography>
                </Stack>
            </Box>
        </CardActionArea>
    )
}

export default UsingZarnipal